import { API_URI } from "../../constants/GlobalConstants";
import { IMAGE_TO_TEXT_CREDIT_GET_FAIL, IMAGE_TO_TEXT_CREDIT_GET_REQUEST, IMAGE_TO_TEXT_CREDIT_GET_SUCCESS, IMAGE_TO_TEXT_DELETE_FAIL, IMAGE_TO_TEXT_DELETE_REQUEST, IMAGE_TO_TEXT_DELETE_SUCCESS, IMAGE_TO_TEXT_FETCH_ALL_FAIL, IMAGE_TO_TEXT_FETCH_ALL_REQUEST, IMAGE_TO_TEXT_FETCH_ALL_SUCCESS, IMAGE_TO_TEXT_FETCH_BY_ID_FAIL, IMAGE_TO_TEXT_FETCH_BY_ID_REQUEST, IMAGE_TO_TEXT_FETCH_BY_ID_SUCCESS } from "../../constants/ImageToOrderConstants";
import axios from "axios";


export const fetchImageToOrderBy = () => async (dispatch, getState) => {
    try {
      dispatch({ type: IMAGE_TO_TEXT_FETCH_ALL_REQUEST });
  
      const {
        userLogin: { userInfo },
      } = getState();
  
      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
  
      const { data } = await axios.get(`${API_URI}/api/image-to-text/all`, config);
      dispatch({ type: IMAGE_TO_TEXT_FETCH_ALL_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: IMAGE_TO_TEXT_FETCH_ALL_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };
  
  // Fetch record by ID
  export const fetchImageToOrderById = (id,token) => async (dispatch) => {
    try {
      dispatch({ type: IMAGE_TO_TEXT_FETCH_BY_ID_REQUEST });
  

  
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
  
      const { data } = await axios.get(`${API_URI}/api/img-to-text/${id}`, config);
      dispatch({ type: IMAGE_TO_TEXT_FETCH_BY_ID_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: IMAGE_TO_TEXT_FETCH_BY_ID_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };
  
  // Delete record by ID
  export const deleteImageToOrderById = (id) => async (dispatch, getState) => {
    try {
      dispatch({ type: IMAGE_TO_TEXT_DELETE_REQUEST });
  
      const {
        userLogin: { userInfo },
      } = getState();
  
      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
  
      await axios.delete(`${API_URI}/api/image-to-text/${id}`, config);
      dispatch({ type: IMAGE_TO_TEXT_DELETE_SUCCESS });
    } catch (error) {
      dispatch({
        type: IMAGE_TO_TEXT_DELETE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };



  export const getImgOrderCreditData = () => async (dispatch, getState) => {
    try {
      dispatch({ type: IMAGE_TO_TEXT_CREDIT_GET_REQUEST });
  
      const { userInfo } = getState().userSignIn; 
  
      const config = {
        headers: {
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
  
      const { data } = await axios.get(`${API_URI}/api/img-to-text/credits-fetch`, config); 
      dispatch({ type: IMAGE_TO_TEXT_CREDIT_GET_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: IMAGE_TO_TEXT_CREDIT_GET_FAIL,
        payload: error.response && error.response.data.message ? error.response.data.message : error.message,
      });
    }
  };